function setCookie(e, t, o) {
	let r = new Date;
	r.setTime(r.getTime() + 864e5 * o);
	let s = "expires=" + r.toUTCString();
	document.cookie = e + "=" + t + ";" + s + ";path=/"
}

function getCookie(e) {
	let t = e + "=",
		o = document.cookie.split(";");
	for (let r = 0; r < o.length; r++) {
		let s = o[r];
		for (;
			" " == s.charAt(0);) s = s.substring(1);
		if (0 == s.indexOf(t)) return s.substring(t.length, s.length)
	}
	return null
}

function mobileSlider(e, t) {
	if(!e.length || !jQuery.fn.slick) return;
	e.hasClass("slick-initialized") && e.slick("unslick"), 767 > jQuery(window).width() && e.slick(t)
}

function wishlistWatcher() {}



function counter(e, t, o, r) {
	let s = t,
		l = o > t ? 1 : -1,
		c = setInterval(() => {
			s += l, e.textContent = s, s == o && clearInterval(c)
		}, Math.abs(Math.floor(r / (o - t))))
}
jQuery(document).ready(function(e) {
	jQuery(".storyLineCTA").on("click", function() {
		let e = jQuery(this).parents(".shopify-section").next().find(".storyLineRow"),
			t = jQuery("#header");
		jQuery("html, body").animate({
			scrollTop: e.offset().top - t.outerHeight()
		}, "slow")
	}), 
	jQuery(".materialCTA").on("click", function() {
    let e = jQuery(this).data("target") ? jQuery(this).data("target") : jQuery(this).parents(".shopify-section").next().find(".sectionRow");

    if (jQuery(e).length > 0) {
        jQuery("html, body").animate({
            scrollTop: jQuery(e).offset().top - jQuery("#header").outerHeight()
        }, "slow");
    } else if (jQuery(this).parents(".shopify-section").next(".shopify-section").length > 0) {
        jQuery("html, body").animate({
            scrollTop: jQuery(this).parents(".shopify-section").next(".shopify-section").offset().top - jQuery("#header").outerHeight()
        }, "slow");
    } else {
        jQuery("html, body").animate({
            scrollTop: jQuery("#shopify-section-footer").offset().top - jQuery("#header").outerHeight()
        }, "slow");
    }
});

	 jQuery(".gotoReview").on("click", function() {
		let e = jQuery("#header");
		jQuery("html, body").animate({
			scrollTop: jQuery("#yotpo-reviews").offset().top > 0 ? jQuery("#yotpo-reviews").offset().top - e.outerHeight() : jQuery("#shopify-section-trustpilot-section").offset().top - e.outerHeight()
		}, "slow")
	});
	mobileSlider(jQuery(".mythsBlocks"), {
		arrows: !1,
		autoplay: !1,
		cssEase: "linear",
		dots: !0,
		infinite: !0,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '10px'
	}), jQuery(".myCustomAddToCart").on("click", function() {

		if (jQuery(this).hasClass('bundle_all_var_cart')) {
			if(document.querySelector('.prd-var-id')) document.querySelector('.prd-var-id').value = jQuery(this).attr('all_of_them');
			jQuery(this).parents(".formWrapper").find('[type="submit"]').click();
			document.body.classList.add('bundle_prd_add_to_cart_progressing');
		}

		else if(document.querySelector(".products_variant_show") || document.querySelector('#prd_variants_main_js')){

			if ($('.no-var-id')) {
				let checkCondition;
				if (document.querySelector(".custom-select-trigger")) {
					checkCondition = $("#sources").attr("placeholder") == $(".custom-select-trigger p").html() || $('.select__fit')?.is(':checked') != true
				}
				else if (document.querySelector('#prd_variants_main_js')) {
					checkCondition = ![...document.querySelectorAll('.styled_option_input')].some(input => input.checked);
				}
				else{
					checkCondition = $('.select__fit').is(':checked') != true
				}
	
				if (checkCondition) {
					$('.AddToCart_btn_js').css({"opacity": "50%"})
					$('.select_your_size').css("display", "block");
				}
				else{
					$('.AddToCart_btn_js').css({"opacity": "100%"})
					$('.select_your_size').css("display", "none");
					jQuery(this).parents(".formWrapper").find('[type="submit"]').click()
				}
			}
			else{
				jQuery(this).parents(".formWrapper").find('[type="submit"]').click()
			}

		}
		else{
			jQuery(this).parents(".formWrapper").find('[type="submit"]').click()
		}

	}), jQuery(".stickCartInner .quantity").on("change", function() {
		jQuery(".newProductTemplate .quantity").val(jQuery(this).val())
	}), jQuery(".stickCartInner .myCustomAddToCart").on("click", function() {
		jQuery(".newProductTemplate .formWrapper").find('[type="submit"]').click()
	}), jQuery(".newProductTemplate .product-wrapper .main-arrow-box.left").on("click", function() {
		let e = jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail.active"),
			t = e.attr("data-slider-no"),
			o = jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").length;
		e.length == e.prev().length ? jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").eq(t - 1 - 1).click() : jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").eq(o - 1).click()
	}), jQuery(".newProductTemplate .product-wrapper .main-arrow-box.right").on("click", function() {
		let e = jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail.active"),
			t = e.attr("data-slider-no");
		jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").length, e.length == e.next().length ? jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").eq(t - 1 + 1).click() : jQuery(".product-wrapper .product-thumbnails .thumbnail-wrapper .thumbnail").eq(0).click()
	})
});
const sections = document.querySelectorAll(".animate"),
	obs = new IntersectionObserver(e => {
		e.forEach(e => {
			e.target.dataset.duration && e.target.dataset.number && !e.target.classList.contains("animated") && counter(e.target, 0, e.target.dataset.number, e.target.dataset.duration), e.target.classList.toggle("animate", !e.isIntersecting), e.target.classList.toggle("animated", e.isIntersecting)
		})
	});
sections.forEach(e => {
	obs.observe(e)
});
const popupOpeners = document.querySelectorAll(".popupOpener");
popupOpeners.forEach(e => {
	e.addEventListener("click", function() {
		let e = this.dataset.target;
		KlaviyoSubscribe.attachToModalForm(`#${e}`, {
			extra_properties: {
				$source: "Sheep Newsletter",
				Brand: "Klaviyo"
			},
			delay_seconds: .01,
			hide_form_on_success: !1,
			ignore_cookie: !0,
			success_message: !1,
			success: function(e) {
				e.parents(".klaviyo_modal_custom").find(".klaviyo_header_close").click();
				var t = e.find('[name="email"]').val();
				_learnq.push(["identify", {
					$email: t
				}]), _learnq.push(["track", "Sheep Newsletter"])
			}
		})
	})
});
const yotpoMainWidget = document.querySelector(".yotpo-main-widget");
if (yotpoMainWidget) {

	function siteReview() {
		document.querySelectorAll(".yotpo-all").forEach(e => {
			if (e.style.display = "block", e.closest(".product-title") && e.querySelector(".yotpo-review-stars") && e.querySelector(".yotpo-num-of-reviews")) {
				let t = e.querySelector(".yotpo-review-stars").innerHTML,
					o = e.querySelector(".yotpo-num-of-reviews").innerHTML;
				reviews = `<div class="yotpo bottomLine yotpo-medium">
				<div class="yotpo-display-wrapper">
					<div class="standalone-bottomline" data-source="default" tabindex="-1">
						<div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">
							<span class="yotpo-stars">
								${t}
							</span>
							<a href="javascript:void(0)" class="text-m" aria-label="${o}" tabindex="-1">${o}</a>
							<div class="yotpo-clr"></div>
						</div>
						<div class="yotpo-clr"></div>
					</div>
					<div class="yotpo-clr"></div>
				</div>
			</div>`, e.innerHTML = reviews
			}
		})
	}

	let e = new MutationObserver(function(e) {
			e.forEach(function(e) {
				let t = document.querySelector('li[data-type="site"]');

				if (window.location.href.indexOf('otaa-white-shirt') != -1 || window.location.href.indexOf('shirt') != -1) {
					document.querySelectorAll(".yotpo-product").forEach(e => {
							e.style.display = "none"
						}), siteReview()
						if(t) {
						let o = document.createEvent("MouseEvents");
						o.initEvent("click", !0, !1), t.dispatchEvent(o);
						// let r = document.querySelector('li[data-type="product"]');
						// r && (r.style.display = "none")
					}
				}
				else{
					if (null == e.target.querySelector(".yotpo-first-review") ? (document.querySelectorAll(".yotpo-product").forEach(e => {
						e.style.display = "block"
					}), document.querySelectorAll(".yotpo-all").forEach(e => {
						e.style.display = "none"
					})) : (document.querySelectorAll(".yotpo-product").forEach(e => {
						e.style.display = "none"
					}), siteReview()), t) {
					let o = document.createEvent("MouseEvents");
					o.initEvent("click", !0, !1), t.dispatchEvent(o);
					let r = document.querySelector('li[data-type="product"]');
					r && (r.style.display = "none")
				}
				}
			})
		}),
		t = {
			attributes: !0,
			childList: !0,
			characterData: !0
		};
	e.observe(yotpoMainWidget, t)
}
// document.addEventListener("DOMContentLoaded", async function() {
// 	setTimeout(async function() {
			
// 		let e = getCookie("currency"),
// 			t = new URLSearchParams(window.location.search).get("currency");
// 		if (t) {
// 			await setCookie("currency", t, 1);
// 			return
// 		}
// 		if (null == e) {
			
// 			let {
// 				currency: o
// 			} = await (await fetch("https://api.ipregistry.co/?key=qfaafhkmboa56uc8")).json();
// 			if (!o) return console.log("No currency found or api stopped"), !1;
// 			if (!$("#currency_form .nice-select ul li[data-value='" + o.code + "']").length > 0) return console.log("Not a store currency"), !1;
// 			$(".product .arrival_time").hide(), setTimeout(function() {
// 				fetch("/cart/update.js", {
// 					method: "POST",
// 					credentials: "same-origin",
// 					headers: {
// 						"Content-Type": "application/json"
// 					},
// 					body: JSON.stringify({
// 						currency: o.code
// 					})
// 				}), setCookie("currency", o.code, 1)
// 			}, 1e3);
// 			let r = await (await fetch(`${window.location.href}?currency=${o.code}`)).text(),
// 				s = (new DOMParser).parseFromString(r, "text/html");

// 			if (o.code.trim() === 'USDD') {
// 				localStorage.setItem('userFromUSA', 'true');

// 				const htmlString = `
// 				<div id="main-banner" class="sackers text-center" style="background-color: rgb(255, 184, 0); overflow: hidden; display: block;">
// 					<div class="bar_announce_popup" onclick="openAnnouncePopup()">
// 						<div class="bar-track_announce_popup">
// 							<div class="bar-msg_announce_popup visible_announce_popup" id="msgA_announce_popup">
// 								<span class="bar-flag_announce_popup desktop_only_announce_bar"><img src="https://cdn.shopify.com/s/files/1/0182/8937/files/Flag_of_the_United_States_svg.webp?v=1772775200" alt="United States flag"></span>
// 								<span class="bar-copy_announce_popup desktop_only_announce_bar">NOW SHIPPING FROM THE USA |</span>
// 								<span class="bar-link_announce_popup desktop_only_announce_bar">Details</span>

// 								<span class="bar-flag_announce_popup mobile_only_announce_bar"><img src="https://cdn.shopify.com/s/files/1/0182/8937/files/Flag_of_the_United_States_svg.webp?v=1772775200" alt="United States flag" role="presentation"></span>
// 								<span class="bar-copy_announce_popup mobile_only_announce_bar">NOW SHIPPING FROM THE USA</span>
// 								<span class="bar-sep_announce_popup mobile_only_announce_bar">|</span>
// 								<span class="bar-link_announce_popup mobile_only_announce_bar">Details</span>
// 							</div>
// 						</div>
// 					</div>

// 					<style>
// 						.mobile_only_announce_bar{
// 							display: none;
// 						}
// 						.bar-flag_announce_popup img{
// 							width: 100%;
// 							height: 100%;
// 							max-height: 12px;
// 							top: 3px !important;
// 						}

// 						@media (max-width: 440px) {    
// 							.mobile_only_announce_bar{
// 								display: block;
// 							}
// 							.desktop_only_announce_bar{
// 								display: none;
// 							}
// 						}
// 					</style>
// 				`;

// 				const announcementBarCSS = `
// 					<style class="announcement_bar_css">
// 						body #shopify-section-header.fixed #main-banner {
// 							display: block !important
// 						}

// 						body .custom_mobile_menu_icon.custom_mobile_menu_icon_js,
// 						.annoucementShow.fixed .custom_mobile_menu_icon.custom_mobile_menu_icon_js {
// 							margin-top: 4px;
// 						}

// 						@media screen and (min-width: 1101px) {
// 							body.otaa_collection.scroll {
// 								padding-top: 175px !important;
// 							}
// 						}

// 						@media (min-width: 1300px) {
// 							body #collectionpage .boost-pfs-filter-wrapper .boost-pfs-filter-wrapper-filter-toolbar,
// 							body #collectionpage .boost-pfs-search-panel-product-show>.boost-pfs-filter-tree-h-wrapper {
// 									top: 120px;
// 							}

// 							body.otaa_product.scroll {
// 								padding-top: 175px !important;
// 							}
// 						}

// 						@media only screen and (max-width: 1300px) {
// 							div#search.menuOpen {
// 								top: -34px !important;
// 							}

// 							body #collectionpage .boost-pfs-filter-wrapper .boost-pfs-filter-wrapper-filter-toolbar,
// 							body #collectionpage .boost-pfs-search-panel-product-show>.boost-pfs-filter-tree-h-wrapper {
// 								top: 100px;
// 							}

// 							body #shopify-section-header, #shopify-section-header.annoucementShow.fixed {
// 								padding-top: 0;
// 							}

// 							body #shopify-section-header.annoucementShow.fixed #header{
// 								padding-top: 10px;
// 							}

// 							body#body.otaa_collection, body#body.otaa_collection.scroll {
// 								padding-top: 10% !important;
// 							}

// 							body#body.scroll {
// 								padding-top: 155px;
// 							}
// 						}

// 						@media screen and (max-width: 920px) {
// 							body .bundle_builder_block_container {
// 								top: -8px;
// 							}
// 						}

// 						@media only screen and (max-width: 767px) {
// 							div#search.menuOpen {
// 								top: -56px !important;
// 							}
							
// 							div#search.single_announce.menuOpen {
// 								top: -36px !important;
// 							}

// 							body .custom_mobile_filters {
// 								top: 100px;
// 							}

// 							body ul#cart, .annoucementShow.fixed ul#cart {
// 								top: 24px;
// 							}

// 							body #search, .annoucementShow.fixed #search {
// 								top: 4px;
// 							}

// 							body#body.otaa_collection, body#body.otaa_collection.scroll {
// 								padding-top: 18% !important;
// 							}
// 						}
// 					</style>
// 				`;

// 				const shopifySectionHeader = document.getElementById('shopify-section-header');
// 				shopifySectionHeader.insertAdjacentHTML('afterbegin', htmlString);
// 				shopifySectionHeader.insertAdjacentHTML('afterbegin', announcementBarCSS);


// 				if (document.querySelector('#main-banner')) {
// 					document.querySelector('#main-banner').style.display = 'block';
// 					document.querySelector('#main-banner').classList.remove('d_none');
// 					document.querySelector('#shopify-section-header').classList.add('annoucementShow');
// 					document.querySelector('#header').classList.add('announcementOn');
// 					document.querySelector('.search')?.classList.remove('menuOpen');
// 					document.querySelector('.announcement_bar_css').disabled = false;
// 					setTimeout(openUSAEntryPopup, 2000);
// 				}


// 			}

// 			Array.from(document.querySelectorAll(".nice-select")).forEach((e, t) => {
// 				e.querySelector(`.option[data-value="${o.code}"]`) && (e.classList.value = "", e.classList.add("nice-select", o.code), e.querySelector(".current").innerHTML = o.code)
// 			});
// 			Array.from(s.querySelectorAll(".side-cart-item-price")).forEach((e, t) => {
// 				document.querySelectorAll(".side-cart-item-price")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".subtotal")).forEach((e, t) => {
// 				document.querySelectorAll(".subtotal")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".sackers.cartMons")).forEach((e, t) => {
// 				document.querySelectorAll(".sackers.cartMons")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".product-price")).forEach((e, t) => {
// 							console.log(e.innerHTML);
// 				document.querySelectorAll(".product-price")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".or-price")).forEach((e, t) => {
// 				document.querySelectorAll(".or-price")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".bc-sf-filter-product-item-price")).forEach((e, t) => {
// 				document.querySelectorAll(".bc-sf-filter-product-item-price")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".amount")).forEach((e, t) => {
// 				document.querySelectorAll(".amount")[t].innerHTML = e.innerHTML
// 			});
// 			Array.from(s.querySelectorAll(".boost-pfs-filter-product-item-price")).forEach((e, t) => {
// 				console.log(e);
				
// 				document.querySelectorAll(".boost-pfs-filter-product-item-price")[t].outerHTML = e.outerHTML
// 			});

// 			Array.from(s.querySelectorAll(".bundle_builder_wrapper .bundle_total_price"))?.forEach((e, t) => {
// 				document.querySelectorAll(".bundle_builder_wrapper .bundle_total_price")[t].innerHTML = e.innerHTML
// 			});

// 			document.querySelectorAll(".ctm_price_text .ctm_price")?.forEach((e, t) => {
// 				const targetElement = s.querySelectorAll(".ctm_price_text .ctm_price")[t];
// 				if (targetElement) {
// 					e.innerHTML = targetElement.innerHTML;
// 				}
// 			});

// 			document.querySelectorAll(".mul_cur_elm")?.forEach((e, t) => {
// 				const targetElement = s.querySelectorAll(".mul_cur_elm")[t];
// 				if (targetElement) {
// 					e.innerHTML = targetElement.innerHTML;
// 				}
// 			});
          
//             Array.from(s.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children)?.forEach((e, t) => {
// 				e.getAttribute('data-block-compare-price') && document.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children[t].setAttribute('data-block-compare-price', e.getAttribute('data-block-compare-price'));
// 				e.getAttribute('data-block-actual-price') && document.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children[t].setAttribute('data-block-actual-price', e.getAttribute('data-block-actual-price'));

//               if(e.getAttribute('data-block-actual-price')){
//                 if(e.getAttribute('bundle_discount')){
//                   document.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children[t].setAttribute('bundle_discount', e.getAttribute('bundle_discount'));
//                 }
//                 else if (document.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children[t].getAttribute('bundle_discount')){
//                   document.querySelector(".bundle_inputs_wrapper.bundle_block_btn_container").children[t].removeAttribute('bundle_discount')
//                 }
//               }
// 			});
          
// 			document.querySelector(".policiesContainer") ? document.querySelector(".policiesContainer").innerHTML = s.querySelector(".policiesContainer").innerHTML : null;
// 			document.querySelector(".shippingContent") ? document.querySelector(".shippingContent").innerHTML = s.querySelector(".shippingContent").innerHTML : null;
// 			document.querySelector(".arrival_time.arrival_time_mob p") ? document.querySelector(".arrival_time.arrival_time_mob p").innerHTML = s.querySelector(".arrival_time.arrival_time_mob p").innerHTML : null;

// 		}   
// 	}, 1000);
// });

// const targetNodes = document.querySelectorAll('.formWrapper [type="submit"]'),
// 	config = {
// 		attributes: !0,
// 		childList: !0
// 	},
// 	observeFunction = function(e, t) {
// 		for (let o of e) "attributes" == o.type && document.body.classList.toggle("addedToCart", o.target.classList.contains("inverted"))
// 	},
// 	observer = new MutationObserver(observeFunction);
// Array.from(targetNodes).forEach(e => {
// 	observer.observe(e, config)
// });
const adjustConcernBarPos = () => {
	if (document.querySelector('.floating_add_to_cart_btn')) {
		let stickyAddBtn = document.querySelector('.stickCart.floating_bar_custom')?.offsetHeight;
		if (stickyAddBtn) {
			document.documentElement.style.setProperty('--stickyCartBottom', (stickyAddBtn - 5) + 'px');
		}
	}
}

const formWrapper = document.querySelector(".newProductTemplate .formWrapper"),
	formObserver = new IntersectionObserver(e => {
		document.body.classList.toggle("crossedCart", e[0].boundingClientRect.bottom < 1)
		var _ch; try { _ch = localStorage.getItem("concentHide"); } catch(e) { _ch = null; } if (!_ch) adjustConcernBarPos();
	});
formWrapper && formObserver.observe(formWrapper), document.addEventListener("readystatechange", function() {
	if ("complete" == document.readyState) {
		document.querySelectorAll(".yotpo-store-owner .yotpo-user-name, .yotpo-comment-title")?.forEach(e => {
			e.innerHTML = "The Brothers at OTAA";
		});

		// setTimeout(() => {
		// 	let e = document.querySelectorAll(".yotpo-nav-content .yotpo-review-media-wrapper-mobile img.image-review");
		// 	for (let t = 0; t < e.length; t++) document.querySelector(".yotpo_full_width_image_inner_2").innerHTML += `<img class="review__images" src="${e[t].src.replace("square", "original")}">`;
		// }, 5000);
		document.querySelector(".black__friday__form button.needsclick") && (document.querySelector(".black__friday__form_btn").style.display = "block", document.querySelector(".black__friday__form_btn").addEventListener("click", function() {
			document.querySelector(".black__friday__form button.needsclick").click(), setTimeout(() => {
				this.style.display = "none"
			}, 500)
		})), setTimeout(() => {
			$("div.boost-pfs-search-suggestion-mobile-top-panel form").append('<span class="search__close"></span>')
		}, 1e3)

		if (document.querySelector(".shirt_size_popup_v2") && typeof(sizeAppFun) == 'function' ) {
			sizeAppFun();
		}

		// get total review
		// if (document.querySelector(".review_page")) {
		// 	if (document.querySelector(".total_reviews .prd_count").innerHTML === '') {
		// 		let prdRev = document.querySelector(".reviews-qa-label");
		// 		if(prdRev){
		// 			prdRev = prdRev.innerHTML.replace(/\D/g, "");
		// 			document.querySelector("#testimonials-tab-site").click();
		// 			document.querySelector(".total_reviews .prd_count").innerHTML = prdRev;
		// 			document.querySelector(".Review_head .review_Count").innerHTML = parseInt(prdRev) + siteRev;
		// 			document.querySelector(".Review_head").style.visibility = "visible";
		// 			document.querySelector(".total_reviews").style.visibility = "visible";
		// 		}
		// 	}
		// }

		// show tag on instashop slider product page
		instashopTag();

		// google concern bar
		const currencyName = document.querySelector("#search form span.current");
		// show consent bar only gbp and eur currency
		if (currencyName && (currencyName.innerText === "GBP" || currencyName.innerText === "EUR")) setTimeout(() => GoogleConcernBar(), 1000);
	}
}),
//  jQuery(document).on("click", ".yotpo-modal-body", function() {
	// document.querySelector(".yotpo_full_width_image_inner_2").innerHTML = "", setTimeout(() => {
	// 	var e = $(".yotpo-nav-content .yotpo-review-media-wrapper-mobile img.image-review");
	// 	for (let t = 0; t < e.length; t++) document.querySelector(".yotpo_full_width_image_inner_2").innerHTML += `<img class="review__images" src="${e[t].src.replace("square", "original")}">`
	// }, 2e3)
// })
jQuery("body.product").on("click", ".yotpo-nav-content img.image-review", function() {
	let e = $(this).attr("src");
	e = e.replace("square", "original"), $(".yotpo_full_width_image").css("display", "block"), $("img.yotpo_full_width_image_img").attr("src", e)
}), jQuery(".yotpo_full_width_image_icon").click(function() {
	$(".yotpo_full_width_image").css("display", "none"), $("body").css("overflow", "visible")
}), jQuery(".yotpo_full_width_image_overlay").click(function() {
	$(".yotpo_full_width_image").css("display", "none"), $("body").css("overflow", "visible")
});
const mobCartBtn = document.querySelector(".AddToCart_btn_js");

function myFunction(e) {
	if (e.matches) {
		if (mobCartBtn) {
			function t() {
				//window.pageYOffset > mobCartBtn.offsetTop + mobCartBtn.clientHeight ? document.querySelector(".float_cart_btn_hide").classList.add("Cart_btn_mob_show") : window.innerHeight + window.pageYOffset < mobCartBtn.offsetTop + 20 + mobCartBtn.clientHeight ? document.querySelector(".float_cart_btn_hide").classList.add("Cart_btn_mob_show") : document.querySelector(".float_cart_btn_hide").classList.remove("Cart_btn_mob_show")
    			
                let floatCartBtnHide = document.querySelector(".float_cart_btn_hide");
                
                // Check if the element exists before accessing its classList
                if (floatCartBtnHide) {
                    if (window.pageYOffset > mobCartBtn.offsetTop + mobCartBtn.clientHeight || window.innerHeight + window.pageYOffset < mobCartBtn.offsetTop + 20 + mobCartBtn.clientHeight) {
                        floatCartBtnHide.classList.add("Cart_btn_mob_show");
                    } else {
                        floatCartBtnHide.classList.remove("Cart_btn_mob_show");
                    }
                }
              
            }
			document.addEventListener("scroll", function() {
				t()
			}, { passive: true })
		}
		let o = document.querySelector("body");
		if (new MutationObserver(function() {
				document.querySelector("body.boost-pfs-search-suggestion-open-body") ? window.pageYOffset < 50 && document.querySelector("#shopify-section-header").classList.add("fixed") : window.pageYOffset < 50 && document.querySelector("#shopify-section-header")?.classList.remove("fixed")
			}).observe(o, {
				attributes: !0
			}), document.querySelector(".custom_mobile_filter_options")) {
			function r() {
				setTimeout(() => {
					const filterCount = document.querySelector(".custom_mobile_filters_result .filters__result span.filter_result_count");
					const boostResult = document.querySelector(".boost-pfs-filter-show-result .boost-pfs-filter-number-result");
					if (filterCount && boostResult) filterCount.innerHTML = boostResult.innerHTML
				}, 1500)
			}
			document.querySelector(".custom_mobile_filter_options").addEventListener("click", function(e) {
				this.parentElement.classList.add("custom_mobile_filters_open"), setTimeout(() => {
					this.classList.add("custom_mobile_filter_fixed")
				}, 10), document.querySelector(".boost-pfs-filter-tree-content") && (document.querySelector(".boost-pfs-filter-wrapper") && e.target.closest("body").querySelector(".boost-pfs-filter-wrapper").classList.add("main_filter_div"), document.querySelector("#shopify-section-search-template-boost-pfs-filter") && e.target.closest("body").querySelector("#shopify-section-search-template-boost-pfs-filter").classList.add("main_filter_div")), document.body.classList.add("overflow__hidden"), document.querySelector(".custom_mobile_filters_result .filters__result span.filter_result_count").innerHTML = document.querySelector(".boost-pfs-filter-show-result .boost-pfs-filter-number-result").innerHTML
			}), document.querySelector(".custom_mobile_filters_sort").addEventListener("click", function(e) {
				this.parentElement.classList.add("custom_mobile_filters_open"), setTimeout(() => {
					this.classList.add("custom_mobile_filter_fixed")
				}, 10), document.querySelector(".boost-pfs-filter-wrapper-filter") && e.target.closest("body").querySelector(".boost-pfs-filter-wrapper-filter").classList.add("open_side_filters"), document.querySelector(".boost-pfs-filter-toolbar-show-sort-by-mobile") && e.target.closest("body").querySelector(".boost-pfs-filter-toolbar-show-sort-by-mobile").classList.add("open_side_filters"), document.body.classList.add("overflow__hidden"), document.querySelector(".custom_mobile_filters_result .filters__result span.filter_result_count").innerHTML = document.querySelector(".boost-pfs-filter-show-result .boost-pfs-filter-number-result").innerHTML
			}), document.querySelector(".custom_mobile_filters_icon").addEventListener("click", function(e) {
				document.body.classList.remove("overflow__hidden"), this.parentElement.classList.remove("custom_mobile_filters_open"), document.querySelector(".custom_mobile_filter_fixed")?.classList.remove("custom_mobile_filter_fixed"), document.querySelector(".open_side_filters") && document.querySelector(".open_side_filters").classList.remove("open_side_filters"), document.querySelector(".main_filter_div") && document.querySelector(".main_filter_div").classList.remove("main_filter_div")
			}), document.querySelector(".custom_mobile_filters_result .filters__result").addEventListener("click", function() {
				setTimeout(() => {
					document.querySelector(".custom_mobile_filters_icon").click()
				}, 300)
			}), document.querySelector(".custom_mobile_filters_result .filters__clear").addEventListener("click", function() {
				setTimeout(() => {
					if (document.querySelector(".boost-pfs-filter-refine-by .boost-pfs-filter-clear-all") && document.querySelector(".boost-pfs-filter-refine-by .boost-pfs-filter-clear-all").click(), r(), -1 == window.location.href.indexOf("search")) {
						var e = window.location.href.substring(0, window.location.href.indexOf("?"));
						window.history.pushState({
							path: e
						}, "", e)
					} else {
						var e = window.location.href.substring(0, window.location.href.indexOf("&sort"));
						window.history.pushState({
							path: e
						}, "", e)
					}
					document.querySelector(".filter_counting").innerHTML = ""
				}, 300)
			}), document.querySelector(".custom_mobile_filters_overlayer").addEventListener("click", function() {
				document.querySelector(".custom_mobile_filters_icon").click()
			}), jQuery("body").on("click", ".boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown li a", function() {
				jQuery(".custom_mobile_filters_icon").click()
			}), jQuery("body").on("click", ".boost-pfs-filter-option-content .boost-pfs-filter-option-content-inner ul li button", function() {
				r()
			})
		}
	}
}
var mobCssJs = window.matchMedia("(max-width: 767px)");
myFunction(mobCssJs), mobCssJs.addListener(myFunction);
let siteUrl = window.location.href.indexOf("?sidecart=1"); - 1 != siteUrl && setTimeout(function() {
	document.querySelector("#cart .cart-link")?.click()
}, 3e3), $(document).ready(function() {
	// window.location.href.indexOf("/cart") > -1 && (window.location.href = "/?sidecart=1")
});
$("#header #search .custom_mobile_menu_icon span").click(function() {
	if (document.querySelector('#main-banner') && !document.querySelector('#main-banner.d_none')) {
		$('#search').toggleClass("menuOpen")
	}
	$(".custom_mobile_menu_icon ").toggleClass("custom_mobile_menu_icon_js")
}), $("#mobNavigation li ul.weddings").prev().removeClass("arrow-down");
const mobileNavItem = document.querySelectorAll("#mobNavigation ul#nav li");
let mobileNavPath;
for (let i = 0; i < mobileNavItem.length; i++) mobileNavItem[i].addEventListener("click", function e(t) {
	this.querySelector(".arrow-down") ? (mobileNavPath = this, t.preventDefault(), this.classList.toggle("custom_menu_dropdown_js"), this.parentElement.classList.toggle("nav_bar_js"), this.parentElement.parentElement.classList.toggle("nav__js"), document.querySelector(".menu_custom_icons_items").classList.toggle("menu_custom_icons_items_hide"), document.querySelector("#mobNavigation").scrollTop = 0, document.querySelector("#mobNavigation").classList.toggle("mobNavigation_js")) : this.querySelector("a").click()
});
let mobileNavInner = document.querySelectorAll("#mobNavigation ul#nav li ul li");
for (let j = 0; j < mobileNavInner.length; j++) mobileNavInner[j].addEventListener("click", function() {
	mobileNavPath.classList.toggle("custom_menu_dropdown_js"), mobileNavPath.parentElement.classList.toggle("nav_bar_js"), mobileNavPath.parentElement.parentElement.classList.toggle("nav__js"), document.querySelector("#mobNavigation").querySelector(".menu_custom_icons_items").classList.toggle("menu_custom_icons_items_hide"), document.querySelector("#mobNavigation").classList.toggle("mobNavigation_js"), window.location = this.querySelector("a").href
});
const shopByCategory = document.querySelectorAll(".shopByCategory .shopByCategoryItem");
for (let i = 0; i < shopByCategory.length; i++) shopByCategory[i].setAttribute("data-category", 1 + i), document.querySelector(".shopByCategories_dots").innerHTML += `<span class="shopByCategories_dots_item" data-shopDots="${1 + i}"></span>`;

function shopCategoryFun(e) {
	if (e.matches && shopByCategory[0]) {
		let t = new IntersectionObserver(e => {
			e.forEach(e => {
				e.target.classList.toggle("shop__active", e.isIntersecting)
			})
		});
		shopByCategory.forEach(e => {
			t.observe(e)
		})
	}
}
shopCategoryFun(mobCssJs), mobCssJs.addListener(shopCategoryFun);
let mutationTarget = document.querySelectorAll(".shopByCategory .shopByCategoryItem"),
	categoryObserver = new MutationObserver(function(e) {
		e.forEach(function(e) {
			if (document.querySelector(".shop__active")) {
				let t = document.querySelectorAll(".shop__active")[1].getAttribute("data-category");
				document.querySelectorAll(".shopByCategories_dots_item").forEach(e => {
					e.classList.remove("shop_dot_active")
				}), document.querySelector(".shopByCategories_dots").querySelector(`[data-shopdots='${t}']`).classList.add("shop_dot_active")
			}
		})
	});
var config2 = {
	attributes: !0,
	childList: !0,
	characterData: !0
};

function kalavio_popup() {
	window._klOnsite = window._klOnsite || [], window._klOnsite.push(["openForm", "WbXqZG"])
}
mutationTarget.forEach(e => {
	categoryObserver.observe(e, config2)
});
const footerCol = document.querySelectorAll(".footer--column--image");
for (let i = 0; i < footerCol.length; i++) footerCol[i].addEventListener("click", function() {
	this.parentElement.classList.toggle("js_footer_accordian")
});
// const checkOutDiv = document.querySelector(".hc-append");
// let checkOutDivOb = new MutationObserver(function() {
// 	checkOutDiv && (document.querySelector(".rebuyApp_product_recommended") ? document.querySelector(".empty_cart_grid") ? document.querySelector(".rebuyApp_product_recommended").style.display = "none" : document.querySelector(".rebuyApp_product_recommended").style.display = "block" : $(".hc-append").after('<div class="rebuyApp_product_recommended" st"><div data-rebuy-id="71036"></div></div>'))
// });
// checkOutDivOb.observe(checkOutDiv, config2);
// const rebuyDiv = document.querySelector("#mini-cart");
// let checkOutDivOb2 = new MutationObserver(function() {
// 	document.querySelector(".rebuyApp_product_recommended") && $(".rebuyApp_product_recommended .flickity-slider:empty").parent().hide()
// });
// var configNew = {
// 	attributes: !0,
// 	childList: !0,
// 	characterData: !0,k
// 	subtree: !0
// };
// if (checkOutDivOb2.observe(rebuyDiv, configNew), 
	// $(document).ready(function() {
	// 	document.querySelector(".rebuyApp_product_recommended") || $(".hc-append").after('<div class="rebuyApp_product_recommended" style="display:none;"><div data-rebuy-id="71036"></div></div>')
	// }),
	document.querySelector(".searchPop_overlay")?.addEventListener("click", function() {
		this.parentElement.removeAttribute("class"), window.pageYOffset < 50 && document.querySelector("#shopify-section-header")?.classList.remove("fixed");
		document.querySelector('.search_opened')?.classList.remove('search_opened');
	}), document.querySelector(".collection-description")
	// )
	 {
	document.querySelectorAll(".collection-description h2").forEach(e => {
		e.innerText.length > 3 ? (e.classList.add("collection_desc_h2"), e.prepend(document.createElement("div"))) : e.style.display = "none"
	});
	for (let o = 0; o < document.querySelectorAll(".collection-description h2 div").length; o++) document.querySelectorAll(".collection-description .collection_desc_h2")[o].classList.add("collection_desc_h2_" + o), document.querySelectorAll(".collection-description h2 div")[o].classList.add("collection_desc_h2_image_" + o)
}

// Function to handle DOM changes (collection/search filter)
const targetNodeBoost = document.querySelector(".boost-pfs-filter-refine-by-wrapper-h");
if (targetNodeBoost) {
    const boostObserver = new MutationObserver(() => {
        const collectionPage = document.querySelector("#collectionpage");
        const searchPanel = document.querySelector(".boost-pfs-search-panel-product-show");
        const filterItems = document.querySelector(".boost-pfs-filter-refine-by-items");
        const filterCount = document.querySelector(".custom_mobile_filter_options .filter_counting");

        if (collectionPage) window.scrollTo(0, collectionPage.offsetTop - 200);
        else if (searchPanel) window.scrollTo(0, searchPanel.offsetTop);

        if (filterItems && filterCount) filterCount.innerHTML = `(${filterItems.childElementCount})`;
    });
    boostObserver.observe(targetNodeBoost, { childList: true, subtree: true });
}

  $(document).ready(function() {
	$("body").on("click", "ul.boost-pfs-filter-filter-dropdown li", function() {
		$(this).find("a")[0].click()
	}), $("body").on("click", "div.boost-pfs-search-suggestion-mobile-top-panel form span", function() {
		$("div.boost-pfs-search-suggestion-mobile-top-panel form").submit()
	}), $("body").on("click", "#search_close", function() {
		$("#searchPop").removeAttr("class")
		// $(".search_opened").removeClass("search_opened")
	})
}), document.querySelector("#searchPop input[name='q']")?.addEventListener("keypress", function(e) {
	if ("Enter" === e.key) {
		var viewAll = document.querySelector(".boost-pfs-search-suggestion-header-view-all a");
		if (viewAll) { e.preventDefault(); viewAll.click(); }
		else { document.querySelector("#searchPop form").submit(); }
	}
}), document.querySelector("#search-submit")?.addEventListener("click", function(e) {
	var viewAll = document.querySelector(".boost-pfs-search-suggestion-header-view-all a");
	if (viewAll) { e.preventDefault(); viewAll.click(); }
	else { document.querySelector("#searchPop form").submit(); }
}), $("body").on("keydown", "div.boost-pfs-search-suggestion-mobile-top-panel form input", function(e) {
	if ("Enter" === e.key) {
		e.preventDefault();
		e.stopImmediatePropagation();
		var q = $(this).val().trim();
		if (q) { window.location.href = "/search?q=" + encodeURIComponent(q); }
	}
}), document.querySelector("#collectionHeader.main_collection_banner") && setTimeout(() => {
	document.querySelector("#collectionHeader.main_collection_banner").style.opacity = 1
}, 1e3);

// $(".custom-select").each(function() {
// 	var classes = $(this).attr("class"),
// 		id = $(this).attr("id"),
// 		name = $(this).attr("name");
// 	var template = '<div class="' + classes + '">';
// 	template += `<div class="custom-select-trigger"><p>${$(this).attr("placeholder")}</p><span></span></div><div class="custom_size_chart"><p onclick="sizeApp()">WHAT'S YOUR SIZE?</p><p class="primary_yellow_color" onclick="sizeChart()">SIZE CHART</p></div><div class="var_overlay"></div><div class="size_chart_desc"><p>Sizes shown are standard to your country</p><p class="primary_yellow_color" onclick="sizeChart()">SIZE CHART</p></div>`;
// 	template += '<div class="custom-options">';
// 	$(this).find("option").each(function() {
// 		template += '<span class="custom-option" data-value="' + $(this).attr("value") + '">' + $(this).attr("value").slice(0,$(this).html().indexOf(" /")) + '</span>';
// 	});
// 	template += '</div></div>';

// 	$(this).wrap('<div class="custom-select-wrapper"></div>');
// 	$(this).hide();
// 	$(this).after(template);
// });

$(".custom-select-trigger").on("click", function() {
	$('.var_overlay').one('click', function() {
		$(".custom-select").removeClass("select_opened");
	});
	$(this).parents(".custom-select").toggleClass("select_opened");
	event.stopPropagation();
});
$(".custom-option").on("click", function(e) {
	var_addToCart_id();
	// if (!$(this).hasClass("custom-option-sold-out")) {
		$(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
		$(this).parents(".custom-options").find(".custom-option").removeClass("selection");
		$(this).addClass("selection");
		$(this).parents(".custom-select").removeClass("select_opened");
		$(this).parents(".custom-select").find(".custom-select-trigger p").text($(this).text());

		if($(this).hasClass("custom-option-sold-out")) {
			setTimeout(() => {
				$('.formWrapper button.needsclick')?.click();
			}, 1000);
		}
	// }
});

function sizeChart() {
	document.querySelector(".size_chart_custom")?.classList.add("size_chart_custom_open");
	document.querySelector("body").classList.add("overflow_hidden");
	const sizeMeasurement = document.querySelector('.custom_size_measurement_main');
	if (sizeMeasurement && !sizeMeasurement.classList.contains('d_none')) {
		sizeMeasurement.classList.add('d_none')
	}
}

function closeSizeChart() {
	document.querySelector(".size_chart_custom")?.classList.remove("size_chart_custom_open");
	document.querySelector("body").classList.remove("overflow_hidden");
}

if (document.querySelector(".custom_size_chart_close")) {
	document.querySelector(".size_chart_custom_overlay").addEventListener("click", closeSizeChart);
	document.querySelector(".custom_size_chart_close").addEventListener("click", closeSizeChart);
}

if (document.querySelector(".size_chart_custom")) {

	const dataSets = {
		tShirtData: [
			{ name: 'chest', sizes: [92, 96, 100, 104, 108] },
			{ name: 'waist', sizes: [90, 94, 98, 102, 106] }
		],
		poloShirtData: [
			{ name: 'chest', sizes: [92, 97, 104, 111, 118] },
			{ name: 'waist', sizes: [90, 95, 102, 109, 116] }
		],
		waistCoatData: [
			{ name: 'chest', sizes: [48.5, 50.5, 52.5, 54.5, 56.5] },
			{ name: 'waistcoat', sizes: [45, 47, 49, 51, 53] },
			{ name: 'bottom', sizes: [47.5, 49.5, 51.5, 53.5, 55.5] },
			{ name: 'shoulder', sizes: [36.2, 37, 37.8, 38.6, 39.4] },
			{ name: 'bottom', sizes: [59, 59.5, 60, 60.5, 61.5] }
		],
		sizeChartOb: [
			{ name: 'europe', sizes: [37, 38, 39, 40, 41, 42, 43, 44, 45, 46] },
			{ name: 'uk', sizes: [14.5, 15, 15.5, 15.7, 16, 16.5, 17, 17.5, 17.75, 18] },
			{ name: 'us', sizes: [14.5, 15, 15.5, 15.7, 16, 16.5, 17, 17.5, 17.75, 18] },
			{ name: 'australia', sizes: [14.5, 15, 15.5, 15.7, 16, 16.5, 17, 17.5, 17.75, 18] }
		],
		slimShirtData: [
			{ name: 'chest width', sizes: [101, 101, 107, 107, 113, 113, 119, 119, 125, 125] },
			{ name: 'waist width', sizes: [92, 92, 98, 98, 104, 104, 112, 112, 120, 120] },
			{ name: 'shoulder length', sizes: [14.9, 14.9, 15.6, 15.6, 16.3, 16.3, 17, 17, 17.7, 17.7] },
			{ name: 'sleeve length', sizes: [65, 65, 66, 66, 66, 66, 67, 67, 67, 67] },
			{ name: 'collarstand length', sizes: [38.4, 39.4, 40.4, 41.4, 42.4, 43.4, 44.4, 45.4, 46.4, 47.4] },
			{ name: 'shirt length', sizes: [78, 78, 79, 79, 80, 80, 81, 81, 82, 82] }
		],
		clasicShirtData: [
			{ name: 'chest width', sizes: [108, 108, 114, 114, 120, 120, 126, 126, 132, 132] },
			{ name: 'waist width', sizes: [101, 101, 107, 107, 113, 113, 121, 121, 129, 129] },
			{ name: 'shoulder length', sizes: [15.1, 15.1, 15.8, 15.8, 16.5, 16.5, 17.2, 17.2, 17.9, 17.9] },
			{ name: 'sleeve length', sizes: [65, 65, 66, 66, 66, 66, 67, 67, 67, 67] },
			{ name: 'collarstand length', sizes: [38.4, 39.4, 40.4, 41.4, 42.4, 43.4, 44.4, 45.4, 46.4, 47.4] },
			{ name: 'shirt length', sizes: [78, 78, 79, 79, 80, 80, 81, 81, 82, 82] }
		],
		nonIronSlimShirtSizeChartOb: [
			{ name: 'europe', sizes: [38, 40, 42, 44, 46, 48] },
			{ name: 'uk', sizes: [15, 15.7, 16.5, 17.5, 18, 18] },
			{ name: 'us', sizes: [15, 15.7, 16.5, 17.5, 18, 18] },
			{ name: 'canada', sizes: [15, 15.7, 16.5, 17.5, 18, 18] }
		],
		nonIronSlimShirt: [
			{ name: 'chest width', sizes: [101, 107, 113, 119, 125, 131] },
			{ name: 'waist width', sizes: [92, 98, 104, 112, 120, 128] },
			{ name: 'shoulder length', sizes: [14.9, 15.6, 16.3, 17, 17.7, 18.4] },
			{ name: 'sleeve length', sizes: [65, 66, 66, 67, 67, 68] },
			{ name: 'collarstand length', sizes: [39.4, 41.4, 43.4, 45.4, 47.4, 49.4] }
		],
		nonIronClassicShirt: [
			{ name: 'chest width', sizes: [108, 114, 120, 126, 132, 138] },
			{ name: 'waist width', sizes: [101, 107, 113, 121, 129, 137] },
			{ name: 'shoulder length', sizes: [46, 48, 50, 52, 54, 56] },
			{ name: 'sleeve length', sizes: [65, 66, 66, 67, 67, 68] },
			{ name: 'collarstand length', sizes: [38, 40, 42, 44, 46, 48] }
		]
	};

	const appendSizeData = (data, selector) => {
    data.forEach(item => {
			const sizeListElement = document.createElement('div');
			sizeListElement.className = 'size_chart_list_inner';
			sizeListElement.innerHTML = `<div class="size_chart_list_size"></div>`;

			const countryName = document.createElement('div');
			countryName.className = 'size_chart_list_name';
			countryName.innerHTML = `<span>${item.name}</span>`;
			document.querySelector(selector[0]).append(countryName);

			item.sizes.forEach(size => {
				const sizeElement = document.createElement('span');
				sizeElement.innerText = size;7
				sizeElement.setAttribute("size-in-cm", size);
				sizeElement.setAttribute("size-in-in", (size / 2.54).toFixed(1));
				sizeListElement.querySelector('.size_chart_list_size').appendChild(sizeElement);
			});
			document.querySelector(selector[1]).appendChild(sizeListElement);
    });
	};

	if (document.querySelector(".t-shirt-template")) {
    appendSizeData(dataSets.tShirtData, [".polo_chart_letter_length", ".polo_size_chart_list"]);
	}
	else if (document.querySelector(".new_shirts_template")) {
		appendSizeData(dataSets.poloShirtData, [".polo_chart_letter_length", ".polo_size_chart_list"]);
	}
	else if (document.querySelector(".waistcoat-vests")) {
		appendSizeData(dataSets.waistCoatData, [".polo_chart_letter_length", ".polo_size_chart_list"]);
	}
	else if (document.querySelector(".non-iron-shirt-template")) {
		appendSizeData(dataSets.nonIronSlimShirtSizeChartOb, [".size_chart_data .size_chart_letter_main", ".size_chart_data .size_chart_list"]);
		var _scFitEl = document.querySelector(".size_chart_custom");
		var _scIsClassic = _scFitEl && _scFitEl.getAttribute("data-chart-fit") === "classic";
		appendSizeData(_scIsClassic ? dataSets.nonIronClassicShirt : dataSets.nonIronSlimShirt, [".polo_chart_letter_length", ".polo_size_chart_list"]);
	}
	else {
		appendSizeData(dataSets.sizeChartOb, [".size_chart_data .size_chart_letter_main", ".size_chart_data .size_chart_list"]);
		appendSizeData(dataSets.slimShirtData, [".slim_shirt_width_length_data .slim_size_chart_letter_length", ".slim_shirt_width_length_data .slim_size_chart_list"]);
		appendSizeData(dataSets.clasicShirtData, [".clasic_shirt_width_length_data .clasic_size_chart_letter_length", ".clasic_shirt_width_length_data .clasic_size_chart_list"]);
	}

	
	function sizeApp() {
		document.querySelector(".custom_size_chart_close").click();
		document.querySelector('.custom_size_measurement_main').classList.remove('d_none')
	};

	if (document.querySelector(".size_chart_custom_inner") && document.querySelector(".custom_size_chart_mw")) {
		document.querySelector(".size_chart_custom_inner").style.cssText = `max-height: ${document.querySelector(".custom_size_chart_mw").offsetHeight}px;`
		document.querySelector(".custom_size_chart_close").style.cssText = `max-height: ${(document.querySelector(".custom_size_chart_mw").offsetHeight + 59)}px;`
	}

	function shirtSizeConver(type) {
		const shirtBodyData = document.querySelectorAll(".shirt_width_length_data .size_chart_list_size span");
		document.querySelector(".active_size_length_type").classList.remove("active_size_length_type");
		shirtBodyData.forEach(elm => {
			if(type === 'in'){
				document.querySelector(".shirt_width_length_type_in").classList.add("active_size_length_type");
				elm.innerHTML = elm.getAttribute("size-in-in");
			}
			else if(type === 'cm'){
				document.querySelector(".shirt_width_length_type_cm").classList.add("active_size_length_type");
				elm.innerHTML = elm.getAttribute("size-in-cm");
			}
		})
	}
}
// end size chart code


const monkeySwing = document.querySelector(".shirt_grid_block_main");
let gentlemansEl;
if (document.querySelector("#guide-articles")) {
	gentlemansEl = document.querySelector("#guide-articles");
}
else if (document.querySelector("#blog-articles")) {
	gentlemansEl = document.querySelector("#blog-articles")
}
else{
	gentlemansEl = document.querySelector("#guide-articles");
}

function shirt_page_cart() {

	if (window.matchMedia("(min-width: 768px)").matches) {
		if (monkeySwing) {
			const monkeySwingOb = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					entry.target.classList.toggle('monkeySwing', entry.isIntersecting);
				});
			});
			monkeySwingOb.observe(monkeySwing);

			if (window.shirtGridSwiper) {
				window.shirtGridSwiper.destroy(true, true);
				window.shirtGridSwiper = null;
			}
		}

		if(gentlemansEl){
			if (gentlemansEl.classList.contains("slick-initialized")) {
				$(gentlemansEl).slick('unslick');
			}
		}
	}
	else {
		if (monkeySwing) {
			var shirtGridEl = document.querySelector('.shirt-grid-swiper');
			if (shirtGridEl && !window.shirtGridSwiper) {
				window.shirtGridSwiper = new Swiper('.shirt-grid-swiper', {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 0,
					pagination: { el: '.shirt-grid-swiper .swiper-pagination', clickable: true }
				});
			}
		}

		if(gentlemansEl){
			if (gentlemansEl.classList.contains("slick-initialized")) {
				$(gentlemansEl).slick('refresh');
			}
			else{
				$(gentlemansEl).slick({
					infinite: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					prevArrow: '<button id="previous_slick" class="custom_slick_arrows slide-arrow prev-arrow"><svg class="slide_svgs" viewBox="0 0 256 512"><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg>',
					nextArrow: '<button id="next_slick" class="custom_slick_arrows slide-arrow next-arrow"><svg class="slide_svgs" viewBox="0 0 256 512"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg>'
				});
			}
		}

	}

}
shirt_page_cart();

// window.addEventListener('resize', function() {
// 	shirt_page_cart();
// });

const shirtGrid = document.querySelector(".shirt_grid_content_items.main_shirt_grid");
if (shirtGrid) {
	const shirtGridOb = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			entry.target.classList.toggle('shirtGridOb', entry.isIntersecting);
		});
	});
	shirtGridOb.observe(shirtGrid);
}

const interceptopn = document.querySelectorAll(".interceptopnOb");
if (interceptopn) {
	const interceptopnOb = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.target.closest(".interceptopn").querySelector(".observerImg")) {
				entry.target.closest(".interceptopn").querySelector(".observerImg").setAttribute("src", entry.target.closest(".interceptopn").querySelector(".observerImg").getAttribute("img-src"), entry.isIntersecting);
			}
		});
	});

	interceptopn.forEach(elm => {
		interceptopnOb.observe(elm);
	})
}


function var_addToCart_id(type = 'nothing') {

	if(!document.querySelector(".products_variant_show")) return;
	// console.log('var_addToCart_id');

	setTimeout(() => {
		const selectInput = document.querySelectorAll(".select__fit");
		let selectFitValue;
		for (let i = 0; i < selectInput.length; i++) {
			if (selectInput[i].checked){
				if (document.querySelector(".variant_option_name .checked_variant_tab")) {
					document.querySelector(".variant_option_name .checked_variant_tab").classList.remove("checked_variant_tab")
				}
				selectInput[i].parentElement.classList.add("checked_variant_tab")
				selectFitValue = selectInput[i].value;
				if (selectFitValue != undefined) {
					selectFitValue = selectFitValue;
				}	
			}	
		}

		// if (type != 'searchParams' && document.querySelector('.custom-select-trigger p') && document.querySelector('.custom-select-trigger p').innerText == 'SIZES') return;
		const cd = document.querySelector('.custom-select-trigger p') ? document.querySelector('.custom-select-trigger p').innerText : '';

		if (selectFitValue != undefined && cd != 'SIZES') {
			let curVarId;
			let curVarPrice;
			if (document.querySelector(".variant_option_size select")) {
				let var_size = document.querySelector(".variant_option_size select").value;
				const variantEl = document.querySelector(`.all_shirt_var_id [var_option1="${selectFitValue}"][var_option2="${var_size}"]`);
				if (!variantEl) return;
				curVarId = variantEl.getAttribute("var_id_v2");
				curVarPrice = variantEl.getAttribute("var_price_v2");
				if (document.querySelector(`.all_shirt_var_id span`)?.getAttribute("var_com_price_v2")) {
					let curVarWasPrice = variantEl.getAttribute("var_com_price_v2");
					document.querySelector('#product-price .was') ? document.querySelector('#product-price .was').innerText = curVarWasPrice : null;

					let comPriceNum = variantEl.getAttribute("var_com_price_v2_num");
					let priceNum = variantEl.getAttribute("var_price_v2_num");
					
					if(document.querySelector('.save_percentage_msg span')) document.querySelector('.save_percentage_msg span').innerText = calculateReturnPercentage(comPriceNum, priceNum);
				}
			}
			else{
				const fitEl = document.querySelector(`.all_shirt_var_id [var_option1="${selectFitValue}"]`);
				if (!fitEl) return;
				curVarId = fitEl.getAttribute("var_id_v2");
				curVarPrice = fitEl.getAttribute("var_price_v2");
				let comPriceNum = fitEl.getAttribute("var_com_price_v2_num");
				let priceNum = fitEl.getAttribute("var_price_v2_num");
				
				if(document.querySelector('.save_percentage_msg span')) document.querySelector('.save_percentage_msg span').innerText = calculateReturnPercentage(comPriceNum, priceNum);
			}

			document.querySelector('.main_product_form .formWrapper input[type="hidden"][id]')?.setAttribute("value", curVarId);
			const priceDisplay = document.querySelector('#product-price .product-price');
			if (priceDisplay) priceDisplay.innerText = curVarPrice;
			const url = window.location.href;
			
			if (type !== 'searchParams') {
				variantQtyValidation(curVarId);
				const newUrl = url.includes('variant=') ? url.replace(/(variant=)[^\&]+/, '$1' + curVarId) : url + (url.includes('?') ? '&' : '?') + 'variant=' + curVarId;
				window.history.pushState({ path: newUrl }, '', newUrl);	
			}
			else{
				if (url.includes('variant=')) variantQtyValidation(curVarId);
			}
			
			// document.querySelector('.myCustomAddToCart.AddToCart_btn_js .product-price') ? document.querySelector('.myCustomAddToCart.AddToCart_btn_js .product-price').innerText = curVarPrice : null;
		}

		// console.log(document.querySelector("#search form span.current") , document.querySelector("#search form span.current").innerText === 'USD' , document.querySelector('#product-price .product-price').getAttribute('data-product-id') == 7098354434130);

		// if (document.querySelector("#search form span.current") && document.querySelector("#search form span.current").innerText === 'USD' && document.querySelector('#product-price .product-price').getAttribute('data-product-id') == 7098354434130 && !document.querySelector('#product-price .was') ) {
		// 	let wasPrice = document.createElement('span');
		// 	wasPrice.classList.add('was');
		// 	wasPrice.innerHTML = '$115 USD';

		// 	document.querySelector('#product-price').prepend(wasPrice);
		// }

		let soldOutClass = document.querySelectorAll(".custom-option-sold-out")
		if (soldOutClass[0]) {
			soldOutClass.forEach(elm => {
				elm.classList.remove("custom-option-sold-out")
			});
		}

		let SoldOutEl = document.querySelectorAll(`.all_shirt_var_id [var_stock="0"]`);
		SoldOutEl.forEach(elm => {
			let soldOutSize = elm.getAttribute("var_option2");
			if (elm.getAttribute("var_option1") == selectFitValue) {
				document.querySelector(`.custom-option[data-value="${soldOutSize}"]`)?.classList.add("custom-option-sold-out")
			}
		});		

		let usdPrd = document.querySelectorAll(`.all_shirt_var_id [prd_type]`);
		if (document.querySelector("#search form span.current")) {
			if (document.querySelector("#search form span.current").innerText.toLowerCase() === 'usd') {
				for (let i = 0; i < usdPrd.length; i++) {
					let usdPrdSize = usdPrd[i].getAttribute("var_option2");
					if (usdPrd[i].getAttribute("var_option1") == selectFitValue) {
						const usdEl = document.querySelector(`.custom-option[data-value="${usdPrdSize}"]`);
						if (usdEl) usdEl.innerHTML = usdPrd[i].getAttribute("prd_type")
					}
				}
			}
		}

		let checkCondition;
		if (document.querySelector(".custom-select-trigger")) {
			checkCondition = $("#sources").attr("placeholder") == $(".custom-select-trigger p").html() || $('.select__fit').is(':checked') != true
		}
		else{
			checkCondition = $('.select__fit').is(':checked') != true
		}
		if (!checkCondition) {
			$('.AddToCart_btn_js').css({"opacity": "100%"})
			$('.select_your_size').css("display", "none");
		}

		// checking if input has disable class and attribute then remove and hide error msg
		let submitInput = document.querySelector('.product-add input[type="submit"]');
		if (submitInput) {
			submitInput.classList.contains("disabled") && submitInput.classList.remove("disabled");
			submitInput.getAttribute("disabled") && submitInput.removeAttribute("disabled");
			document.querySelector(".ajaxified-cart-feedback") ? document.querySelector(".ajaxified-cart-feedback").style.display = "none" : null;
		}

	}, 100);
};



// add sold out functionality in bundle products
document.querySelectorAll('.bundle_prd_qty_div [max_qty]')?.forEach(elm => document.querySelector(`[var_id_v2="${elm.getAttribute('vr_id')}"]`)?.setAttribute('var_stock', elm.getAttribute('max_qty')));



// variant max quantity validation
const variantQtyValidation = (varId) => {

	const prdInput = varId || document.querySelector('input.prd-var-id[type="hidden"]')?.value;
	if(!prdInput) return;
	
	const getCurVarQty = document.querySelector(`.prd_var_qty_info [vr_id="${prdInput}"]`);
	if(!getCurVarQty) return;

	const getCurVarQtyValue = parseInt(getCurVarQty.getAttribute('max_qty'));

	if (getCurVarQtyValue || getCurVarQtyValue === 0) {
		const qtyInput = getCurVarQty?.closest('.quantity-wrapper')?.querySelector('input[name="quantity"]');
		const qtyInputValue = parseInt(qtyInput.value);

		if (qtyInputValue || qtyInputValue === 0) {
			qtyInput.setAttribute('max', getCurVarQtyValue);				

			if (qtyInputValue >= getCurVarQtyValue) {					
				qtyInput.value = getCurVarQtyValue

				if(getCurVarQtyValue === 1) return;

				if (document.querySelector('.custom-select.sources .custom-option')) {
					if (document.querySelector('.custom-select.sources .custom-option.selection')) {
						qtyInput.closest('.quantity-selection')?.setAttribute('qty_msg', `${getCurVarQtyValue === 0 ? 'Out of stock' : `maximum quantity is ${getCurVarQtyValue}`}`);
					}
				}
				else{
					qtyInput.closest('.quantity-selection')?.setAttribute('qty_msg', `${getCurVarQtyValue === 0 ? 'Out of stock' : `maximum quantity is ${getCurVarQtyValue}`}`);
				}

				if (getCurVarQtyValue === 0) {
					const addToCartBtn = getCurVarQty?.closest('.formWrapper')?.querySelector('.formWrapperFooter .without_price');
					// if (addToCartBtn) addToCartBtn.innerText = 'OUT OF STOCK' , addToCartBtn.parentElement.classList.add('disabled'); 
					if (addToCartBtn) addToCartBtn.innerText = 'OUT OF STOCK' , addToCartBtn.parentElement.classList.add('d_none'); 
				}
			
			}
			else{
				document.querySelector('[qty_msg]')?.removeAttribute('qty_msg');
				if(qtyInputValue === 0) qtyInput.value = 1;

				if (getCurVarQtyValue !== 0) {
					const addToCartBtn = getCurVarQty?.closest('.formWrapper')?.querySelector('.formWrapperFooter .without_price');
					if (addToCartBtn && addToCartBtn.innerText === 'OUT OF STOCK') addToCartBtn.innerText = 'ADD TO BAG', 
						// addToCartBtn.parentElement.classList.contains('disabled') && addToCartBtn.parentElement.classList.remove('disabled');
						addToCartBtn.parentElement.classList.contains('d_none') && addToCartBtn.parentElement.classList.remove('d_none');
				}
			}
		}
	}
};

window.variantQtyValidation = variantQtyValidation;

// Calculate save percentage
function calculateReturnPercentage(comPrice, price) {
		// Check if parsing was successful
		if (!isNaN(comPrice) && !isNaN(price)) {
				// Calculate the remaining amount after deduction
				const remainingAmount = comPrice - price;

				// Calculate the discount percentage
				const discountPercentage = (price * 100) / comPrice;

				// Return the result with the original currency symbol and discount percentage
				return Math.round(100 - discountPercentage);
		} else {
				return 'Invalid input';
		}
}
////////////////////////////////////////////////////



const prdForm_V2 = document.querySelector(".main_product_form");
if (prdForm_V2) {
	prdForm_V2.addEventListener("change", function() {
		var_addToCart_id();
	});
}

if (window.pageYOffset > 50) {
	document.querySelector("#shopify-section-header").classList.add("fixed");
}

setTimeout(() => {
	const curCurency = document.querySelector("#search form .nice-select .current");

	const varIntialLoad = () => {
		var_addToCart_id('searchParams');

		setTimeout(() => {
			if(document.querySelector(".products_variant_show")){
				const params = new URL(window.location.href).searchParams;
				const variantId = params.get('variant');
				document.querySelector('.main_product_form .formWrapper input[type="hidden"][id]').setAttribute("value", variantId);

				let curVar = document.querySelector(`.all_shirt_var_id [var_id_v2="${variantId}"]`);

				if (curVar) {
					if (document.querySelector(`.select__fit[value="${curVar.getAttribute("var_option1")}"]`)) {
						document.querySelector(`.select__fit[value="${curVar.getAttribute("var_option1")}"]`).click();
					}
					setTimeout(() => {
						if (document.querySelector(`.custom-option[data-value="${curVar.getAttribute("var_option2")}"]`)) {
							document.querySelector(`.custom-option[data-value="${curVar.getAttribute("var_option2")}"]`).click();
						}
					}, 100);
				}
			}
		}, 100);
	}

	if (curCurency) {
		varIntialLoad();

		const curCurencyOb = new MutationObserver(function(){
			varIntialLoad()
			console.log('ertyui');
			
		});
		
		const currencyConfig = {
			attributes: true,
			childList: true,
			subtree: true
		};
		curCurencyOb.observe(curCurency,currencyConfig)	
	}
}, 200);


const homCat = document.querySelector(".shopByCategories");
if(homCat){
  homCat.style.cssText = `grid-template-columns: repeat(${homCat.childElementCount},1fr);`
}

const domConfig = {
	attributes: true,
	childList: true,
	subtree: true
};

setTimeout(() => {
  function sizeAppFun() {
			
		$("body").append(`<div class="shirt_size_chart" onclick="sizeChart()" style="display: none"><p>Find my size</p><p>Size chart</p><div class="hide_size_fox_logo"></div></div>`)

		$("body").append($(".shirt_size_popup_v2").html())
		$(".shirt_size_popup_v2").remove();

		$("#sizefox").addClass("sizefoxShow");

		// if(document.querySelector(".polo_size_chart")){
		// 	document.querySelector(".polo_size_chart").style.cssText = `display: flex; align-items: center; justify-content: space-between`;
		// }

		if (document.querySelector(".custom_size_chart_close")) {
			document.querySelector(".size_chart_custom_overlay").addEventListener("click", closeSizeChart);
			document.querySelector(".custom_size_chart_close").addEventListener("click", closeSizeChart);
		}

		let sizeIframe = document.querySelector("#sizefox-widget");
		if (sizeIframe) {
			let sizeIframeOb = new MutationObserver(function(){
				if (document.getElementById("sizefox-widget").style.display === "block") {
					document.querySelector(".shirt_size_chart").style.display = "flex";
				}
				else{
					document.querySelector(".shirt_size_chart").style.display = "none";
				}
			});

				sizeIframeOb.observe(sizeIframe,domConfig)	
		}

	}

	if (document.querySelector(".shirt_size_popup_v2")) {
		sizeAppFun();
	}

	
	const sizeTabEl = document.querySelectorAll(".cus_collect_heading label");
	for (let i = 0; i < sizeTabEl.length; i++) {
		sizeTabEl[i].addEventListener("click",function(){
			document.querySelector(".custom_size_chart_mw .checked_size_tab").classList.remove("checked_size_tab");
			document.querySelector(".custom_size_chart_mw .checked_content_tab").classList.remove("checked_content_tab");
			document.querySelector(".custom_size_chart_mw .checked_data_tab").classList.remove("checked_data_tab");
			this.parentElement.classList.add("checked_size_tab");
			if (document.querySelector(".cus_collect_heading_1.checked_size_tab")) {
				document.querySelector(".custom_size_chart_tab.content1").classList.add("checked_content_tab");
				document.querySelector(".shirt_width_length_data_inner.content1").classList.add("checked_data_tab");
			}
			if (document.querySelector(".cus_collect_heading_2.checked_size_tab")) {
				document.querySelector(".custom_size_chart_tab.content2").classList.add("checked_content_tab");
				document.querySelector(".shirt_width_length_data_inner.content2").classList.add("checked_data_tab");
			}
		});
	}

}, 4000);

window.addEventListener("DOMContentLoaded", (event) => {
	if (document.querySelector(".otaa__shirt__new")) {
		document.querySelector("body").classList.add("otaa_new_shirts");
	}

	// show delivery date in australia
	let deliveryMsgEl = document.querySelector(".arrival_time.arrival_time_mob");
	if (deliveryMsgEl) { // delivery messege bar

		// date function with specific timezone 
		function getDateTimeDetails(timeZone) {
			const date = new Date();
			const options = {
				timeZone,
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
				weekday: 'long'
			};

			// month name 
			const monthShortNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

			// date formate type
			const formattedDate = date.toLocaleString('en-AU', options);

			// get data 
			const [weekday, datePart, timePart] = formattedDate.split(', ');
			const [day, month, year] = datePart.split('/').map(Number); // Convert to numbers
			const [hour, minute, second] = timePart.split(':').map(Number); // Convert to numbers
			const dayOfWeek = date.getDay();

			// Calculate total days in the month
			const lastDayOfMonth = new Date(parseInt(year), parseInt(month), 0).getDate();

			return {
					year,
					month,
					monthShortName: monthShortNames[parseInt(month) - 1],  // Get short name for current month
					nextMonthShortName: monthShortNames[parseInt(month == '12' ? '0' : month)],  // Get short name for next month
					day,
					dayOfWeek,
					dayName: weekday,
					time: { hour, minute, second },
					totalDaysInMonth: lastDayOfMonth
			};
		}


		function dateCalculate(country, holidays, delay, countryName, defaultMsg) {
			const dateData = getDateTimeDetails(country); // get specofic country time
			// console.log(dateData);
			// define empty variable
			let deliveryDate, dayWeek, nextMonth = false;
			// get time date data
			const { hour, minute } = dateData.time;
			const { day, dayOfWeek, totalDaysInMonth, year,  month, monthShortName, nextMonthShortName } = dateData;

			// order before 1:30pm
			if (hour < 13 || (hour === 13 && minute <= 30)) { // check order time and define delivery date
				let addDays = dayOfWeek !== 0 && dayOfWeek !== 6 ? (dayOfWeek + delay <= 5 ? delay : (delay + 2)) : (dayOfWeek === 6 ? (delay + 2) : (delay + 1));
				addDays += day;
				deliveryDate = addDays <= totalDaysInMonth ? addDays : (nextMonth = true, addDays - totalDaysInMonth);
				dayWeek = addDays - day;
			}
			else { // order after 1:30 pm
				let addDays = dayOfWeek !== 0 && dayOfWeek !== 6 ? (dayOfWeek + (delay + 1) <= 5 ? (delay + 1) : (delay + 3)) : (dayOfWeek === 6 ? (delay + 2) : (delay + 1));
				addDays += day;
				deliveryDate = addDays <= totalDaysInMonth ? addDays : (nextMonth = true, addDays - totalDaysInMonth);
				dayWeek = addDays - day;
			}
		
			// check holiday
			function dateToString(day,holidayMonth) {
				let formattedMonth = holidayMonth < 10 ? `0${holidayMonth}` : `${holidayMonth}`;
				let holiodayYear = formattedMonth > 12 ? (year + 1) : year;
				formattedMonth = formattedMonth > 12 ? `01` : formattedMonth;
				const formattedDay = day < 10 ? `0${day}` : `${day}`;

				return `${holiodayYear}-${formattedMonth}-${formattedDay}`;
			}

			// get day name
			function getDayName(deliveryDateWithHolidays) {
				const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
				const dateString = dateToString(deliveryDateWithHolidays, nextMonth ? (month + 1) : month);
				const date = new Date(dateString);
				const dayOfWeekNumber = date.getDay();
				
				return daysOfWeek[dayOfWeekNumber];
			}

			// Calculate delivery date weekend
			let week = (dayWeek + dayOfWeek) > 7 ? (dayWeek + dayOfWeek) - 7 : dayWeek + dayOfWeek;
		
			// Calculate holidays and add extra days if holiday falls within delivery period
			let deliveryDateWithHolidays = deliveryDate;
			for (let i = 0; i <= dayWeek; i++) {
				const holidayMonth = totalDaysInMonth >= (day + i) ? month : (month + 1);
				const holidayDay = totalDaysInMonth >= (day + i) ? (day + i) : ((day + i) - totalDaysInMonth);
	
				const dateString = dateToString(holidayDay, holidayMonth);
				if (holidays.hasOwnProperty(dateString)) {

					(day === day + i && (hour > 13 || (hour === 13 && minute >= 30))) ? (deliveryDateWithHolidays, dayWeek) : (deliveryDateWithHolidays++, dayWeek++);

					week = (dayWeek + dayOfWeek) > 7 ? (dayWeek + dayOfWeek) - 7 : dayWeek + dayOfWeek;
					week === 6 ? (deliveryDateWithHolidays += 2, dayWeek += 2) : (week === 0 ? (deliveryDateWithHolidays++, dayWeek++) : (deliveryDateWithHolidays, dayWeek));	

				}
			}
		
			// delivery date
			const formattedDeliveryDate = deliveryDateWithHolidays === 1 ? '1st' : deliveryDateWithHolidays === 2 ? '2nd' : deliveryDateWithHolidays === 3 ? '3rd' : `${deliveryDateWithHolidays}th`;
			// delivery month
			const formattedMonth = nextMonth ? nextMonthShortName : monthShortName;
			// country flag image
			const deliveryCountryFlag = document.querySelector(".arrival_time.arrival_time_mob img").outerHTML;
			// show delivery date msg
			document.querySelector(".arrival_time.arrival_time_mob").innerHTML =
				`<p>
					${deliveryCountryFlag}
					${countryName === "aud"
						? `Fastest Delivery By <span class="del_time" style="color: #FFB800;">${getDayName(deliveryDateWithHolidays)}, ${formattedDeliveryDate} ${formattedMonth}</span>`
					: countryName === "usa"
						? `Get It By ${getDayName(deliveryDateWithHolidays)} ${formattedDeliveryDate} ${formattedMonth} to <span style="color: #FFB800;">USA</span>`
					: defaultMsg}
				</p>`;

		}
		
		// australia holidays
		const austrianHolidays = {
            '2023-11-07': 'Melbourne Cup Day',
            '2023-12-25': 'Christmas Day',
            '2023-12-26': 'Boxing Day',
            '2024-01-01': 'New Year\'s Day',
            '2024-01-26': 'Australia Day',
            '2024-03-29': 'Good Friday',
            '2024-04-01': 'Easter Monday',
            '2024-04-25': 'Ascension Day',
            '2024-06-03': 'Queens Birthday',
            '2024-10-07': 'Labour Day',
            '2024-11-05': 'Melbourne Cup Day',
            '2024-12-25': 'Christmas Day',
            '2024-12-26': 'Boxing Day',
            '2025-01-01': 'New Year\'s Day',
            '2025-01-26': 'Australia Day',
            '2025-04-18': 'Good Friday',
            '2025-04-21': 'Easter Monday',
            '2025-05-30': 'Ascension Day',
            '2025-06-09': 'Queens Birthday',
            '2025-10-06': 'Labour Day',
            '2025-11-04': 'Melbourne Cup Day',
            '2025-12-25': 'Christmas Day',
            '2025-12-26': 'Boxing Day',
        };


		function updateDeliveryMsg() {
			// exclude code when these classes come
			const abTestAusDelivery = document.querySelector(".product-delivery-date-ab");
			const abTestUsaDelivery = document.querySelector(".one_day_del");
			// console.log(abTestUsaDelivery);
			// delivery message default
			const deliveryMessage = document.querySelector('.arrival_time.arrival_time_mob p').innerHTML;

			if (!abTestAusDelivery && !abTestUsaDelivery) { //  exclude code when these classes come
				let countryCurrency = document.querySelector('#product-price .product-price').innerHTML;
				// check currency

				// countryCurrency.includes("AUD") ? dateCalculate('Australia/Sydney', austrianHolidays, 2, 'aud', deliveryMessage) :
				// countryCurrency.includes("USD") ? dateCalculate('Australia/Sydney', austrianHolidays, 3, 'usa', deliveryMessage) : null;

				countryCurrency.includes("AUD") ? dateCalculate('Australia/Sydney', austrianHolidays, 2, 'aud', deliveryMessage) : null;
			}
		}
		updateDeliveryMsg();

		let deliveryMsgOb = new MutationObserver(function(){ // observer if currency change
			updateDeliveryMsg();
		});

		// observe currency changes
		deliveryMsgOb.observe(document.querySelector('#product-price .product-price'), domConfig);
		// deliveryMsgEl.style.opacity = 1;
	}
	// end delivery date


	// pdp tab pannel
	document.querySelectorAll('.tabItemHeader')?.forEach(header => {
		header.addEventListener('click', function() {
			
			if (this.dataset.target === 'reviews') {
				const reviewsSection = document.querySelector('#yotpo-reviews');
				
				if (reviewsSection) {
					const headerOffset = 85; // adjust to your sticky header height
					const top = reviewsSection.getBoundingClientRect().top + window.scrollY - headerOffset;
					window.scrollTo({ top, behavior: 'smooth' });
				}
				return;
			}

			this.closest('.tabHeader').querySelector('.tabItemHeaderActive')?.classList.remove('tabItemHeaderActive');
			this.classList.add('tabItemHeaderActive');

			this.closest('.tabContainer').querySelector('.tabItemActive')?.classList.remove('tabItemActive');
			const newActiveItem = this.closest('.tabContainer').querySelector(`.tabItem[data-target="${this.dataset.target}"]`);
			newActiveItem.classList.add('tabItemActive');

			if (this.dataset.target === 'reviews' && newActiveItem.querySelector('.yotpo-main-widget') && newActiveItem.querySelector('.yotpo-all')) {
				const reviewExist = newActiveItem.querySelector('.reviewsContent .yotpo-main-widget .bottom-line-items .avg-score')				
				newActiveItem.querySelector('.yotpo-main-widget').style.display = reviewExist ? 'block' : 'none';
				newActiveItem.querySelector('.yotpo-all').style.display = reviewExist ? 'none' : 'block';

				newActiveItem.querySelectorAll(".yotpo-comment-title")?.forEach(e => {
					e.innerHTML = "The Brothers at OTAA";
				});
			}

		});
	});

});

function videoPopup(el) {
	const videoPopup = document.querySelector(".video_popup_v2");
	if (videoPopup) {
			videoPopup.classList.add("video_popup_v2_open");
			const videoElement = videoPopup.querySelector("video");
			if (videoElement.src !== el.getAttribute("video_src")) {	
				videoElement.setAttribute("src", el.getAttribute("video_src"));
				videoElement.addEventListener("loadedmetadata", () => videoElement.play());
				videoElement.load();
			}
			else{
				videoElement.play();	
			}
			document.querySelector("body").classList.add("overflow_hidden");
	}
}


function closeVideoPopup() {
	// document.querySelector(".video_popup_v2 video source").removeAttribute("src");
	document.querySelector(".video_popup_v2 video").pause();
	document.querySelector("body").classList.remove("overflow_hidden");
	document.querySelector(".video_popup_v2").classList.remove("video_popup_v2_open");
}

// get total review
if (document.querySelector(".review_page")) {
	async function yotpoSiteReviewFn() {
		try {
			const response = await fetch('https://api.yotpo.com/products/F0wtkH1PAhmlnUjDN37PW0YnopiARHZTIiapUMa6/yotpo_site_reviews/bottomline');
			const data = await response.json();
			let siteRev = await data.response.bottomline.total_reviews;
			document.querySelector(".total_reviews .site_count").innerHTML = siteRev; // show site review

			if (document.querySelector(".total_reviews .prd_count").innerHTML === ''){

				// DOM modified
				const mutationTarget = document.querySelector('#yotpo-testimonials-custom-tab'); // yotpo main div
				const mutationTargetObserver = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {

						let prdRev = document.querySelector("#yotpo-testimonials-product-bottomline .reviews-qa-label"); // review count div
						if (prdRev) {
							mutationTargetObserver.disconnect(); // disconnect observer
							
							prdRev = prdRev.innerHTML.replace(/\D/g, ""); // get product review count

							// select site review first
							document.querySelector("#testimonials-tab-site") ? document.querySelector("#testimonials-tab-site").click() : null;
							
							// append total review in review_Count div class
							document.querySelector(".Review_head .review_Count").innerHTML = parseInt(prdRev) + parseInt(siteRev);
		
							document.querySelector(".total_reviews .prd_count").innerHTML = prdRev;
							document.querySelector(".Review_head").style.visibility = "visible";
							document.querySelector(".total_reviews").style.visibility = "visible";
						}	
					});
				});

				const config = {
					attributes: true,
					childList: true,
					subtree: true
				};
				
				mutationTargetObserver.observe(mutationTarget, config);

				setTimeout(() => {
					mutationTargetObserver.disconnect(); // disconnect observer
				}, 10000);

			}
		}catch(error){
			console.error(error);
		}
	}
	yotpoSiteReviewFn();
}

// product page rebuy similar,recommendation product slider
function rebuyPrevSlide(elm) {
	let curDiv = elm.closest(".product_page_rebuy_widget");
	let rebCusSlide = curDiv.querySelector(".product_page_rebuy_widget .rebuy-widget-content .rebuy-product-grid");
	let element = curDiv.querySelector(".product_page_rebuy_widget .rebuy-widget-content .rebuy-product-grid .rebuy-product-block");
	let styles = window.getComputedStyle(element);
	let fullWidth = element.offsetWidth + parseInt(styles.marginLeft) + parseInt(styles.marginRight);

	let totalScrollLeft = rebCusSlide.scrollLeft;
	let totalSlideWidth = rebCusSlide.scrollWidth;

	if (totalScrollLeft <= 0) return;

	if (window.matchMedia( "(max-width: 767px)" ).matches){
		const srlLeft = (fullWidth * 1) > totalScrollLeft ? totalScrollLeft : (fullWidth * 1);
		rebCusSlide.scrollBy(-(srlLeft), 0);
	}
	else if(window.matchMedia( "(max-width: 960px)" ).matches){
		const srlLeft = (fullWidth * 3) > totalScrollLeft ? totalScrollLeft : (fullWidth * 3);
		rebCusSlide.scrollBy(-(srlLeft), 0);
	}
	else{
		const srlLeft = (fullWidth * 4) > totalScrollLeft ? totalScrollLeft : (fullWidth * 4);
		rebCusSlide.scrollBy(-(srlLeft), 0);
	}
}

function rebuyNextSlide(elm) {
	let curDiv = elm.closest(".product_page_rebuy_widget");
	let rebCusSlide = curDiv.querySelector(".product_page_rebuy_widget .rebuy-widget-content .rebuy-product-grid");
	let element = curDiv.querySelector(".product_page_rebuy_widget .rebuy-widget-content .rebuy-product-grid .rebuy-product-block");
	let styles = window.getComputedStyle(element);
	let fullWidth = element.offsetWidth + parseInt(styles.marginLeft) + parseInt(styles.marginRight);

	let totalScrollLeft = rebCusSlide.offsetWidth + rebCusSlide.scrollLeft;
	let totalSlideWidth = rebCusSlide.scrollWidth;
	
	if (totalScrollLeft >= totalSlideWidth) return;

	if (window.matchMedia( "(max-width: 767px)" ).matches){
		const srlLeft = (fullWidth * 1) + totalScrollLeft > totalSlideWidth ? (totalSlideWidth - totalScrollLeft) : (fullWidth * 1)
		rebCusSlide.scrollBy((srlLeft), 0);
	}
	else if(window.matchMedia( "(max-width: 960px)" ).matches){
		const srlLeft = (fullWidth * 3) + totalScrollLeft > totalSlideWidth ? (totalSlideWidth - totalScrollLeft) : (fullWidth * 3)
		rebCusSlide.scrollBy((srlLeft), 0);
	}
	else{
		const srlLeft = (fullWidth * 4) + totalScrollLeft > totalSlideWidth ? (totalSlideWidth - totalScrollLeft) : (fullWidth * 4)
		rebCusSlide.scrollBy((srlLeft), 0);
	}
}

// show tag on instashop slider product page
function instashopTag() {
	if (document.querySelector(".styledSlider .swiperMain")) {
		if (window.matchMedia( "(min-width: 768px)" ).matches) {
			// Function to get the background image URL from an element
			const getBackgroundImageDimensions = (element, callback) => {
				const url = window.getComputedStyle(element).backgroundImage.slice(5, -2);
				if (!url) return callback(null);

				const img = new Image();
				img.onload = () => callback({ width: img.naturalWidth, height: img.naturalHeight });
				img.src = url;
			};

			document.querySelectorAll('.styledSlider .styledSliderMainImage')?.forEach(elm => {
				getBackgroundImageDimensions(elm, dimensions => {
					if (dimensions) {
						const ratio = dimensions.width / dimensions.height;
						const imgWidth = elm.offsetHeight * ratio;
						const italyTagPos = (elm.offsetWidth + 10) - ((elm.offsetWidth / 2) + (imgWidth / 2));
						elm.querySelector('.instashop_tag').style.right = italyTagPos.toFixed(0) + 'px';
					} else {
						console.log('not get');
					}
				});
			});
		}
		else{
			document.querySelectorAll('.styledSlider .styledSliderMainImage')?.forEach(elm => elm.querySelector('.instashop_tag').style.right = 10 + 'px');
		}
	}
}
setTimeout(() => {
	instashopTag();

	if (document.querySelector('.styledSlider .styledSliderMainImage')) {		
		let lastWidth = window.innerWidth;
		window.addEventListener('resize', () => {
			const currentWidth = window.innerWidth;
			if (currentWidth !== lastWidth) {
				lastWidth = currentWidth;
				instashopTag();
			}
		});
	}
}, 4000);

if (document.querySelector(".ancher_triger")) {
	document.querySelector(".ancher_triger .card_grid_blocks_bottom_btn a").addEventListener("click",function(e){
		e.preventDefault();
		document.querySelector(".collabs-page__cta .collabs-page__cta-main").click();
	})
}

// blog post dropdown
if (document.querySelector(".custom_select_box_title")) {
	document.querySelector(".custom_select_box_title").addEventListener("click",function(){
		this.closest(".custom_select_box").classList.toggle("custom_select_box_open");
	});

	// close dropdown
	document.querySelector("body").addEventListener("click",function(elm){
		if (!elm.target.closest(".custom_select_box")) {
			if (document.querySelector(".custom_select_box_open")) {
				document.querySelector(".custom_select_box_open").classList.remove("custom_select_box_open")
			}
		}
	});

	// show current name in select box 
	const curUrl = window.location.href;
	const categoryTag = document.querySelectorAll(".custom_select_box_inner a");
	categoryTag.forEach(elm => {
		if (curUrl.indexOf(elm.getAttribute("href")) != -1) {
			document.querySelector(".custom_select_box_title h4").innerHTML = elm.innerHTML;
			elm.style.color = "#ffb800";
		}		
	});
}

  // klavio popup
  setTimeout(() => {
		const klavioPopup = new MutationObserver(function() {
				setTimeout(() => {
						let targetDiv = document.querySelector(".klaviyo-form-version-cid_5");
						if (targetDiv) {
								let parentDiv = targetDiv.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
								parentDiv.classList.add("klavio_hidden");
								setTimeout(() => {
										parentDiv.classList.remove("klavio_hidden");
								}, 10000);
							klavioPopup.disconnect();
						}
				}, 50);
		})
		klavioPopup.observe(document.body, { childList: true });
}, 20000);


if (window.matchMedia( "(max-width: 767px)" ).matches){
	// adjust home page banner bottom button
	const viewportHeightEl = window.innerHeight || document.documentElement.clientHeight;
	document.querySelector('.black_friday_23 .content') ? document.querySelector('.black_friday_23 .content').style.top = viewportHeightEl - 130 + 'px' : null;
	document.querySelector('.homepage_presable_btn') ? document.querySelector('.homepage_presable_btn').style.top = viewportHeightEl - 120 + 'px' : null;
	document.querySelector('.shirt_vide_content_btn') ? document.querySelector('.shirt_vide_content_btn').style.top = viewportHeightEl - 90 + 'px' : null;
	document.querySelectorAll('.shirt_vide_content_btn')[1] ? document.querySelectorAll('.shirt_vide_content_btn')[1].style.top = viewportHeightEl - 90 + 'px' : null;
	document.querySelector('.back_friday_24_Btn_wrapper') ? document.querySelector('.back_friday_24_Btn_wrapper').style.top = viewportHeightEl - 90 + 'px' : null;
	document.querySelector('.shirt_vide_content_btn_anniversary') ? document.querySelector('.shirt_vide_content_btn_anniversary').style.top = viewportHeightEl - 180 + 'px' : null;
	document.querySelector('.banner_review_sticker') ? document.querySelector('.banner_review_sticker').style.top = viewportHeightEl - 50 + 'px' : null;
	document.querySelector('.father_day_sale_dicsount') ? document.querySelector('.father_day_sale_dicsount').style.top = viewportHeightEl - 100 + 'px' : null;   
	document.querySelector('.double_ctm_banner_bottom_inner') ? document.querySelector('.double_ctm_banner_bottom_inner').style.top = viewportHeightEl - 75 + 'px' : null;   
	document.querySelector('.site_wide_sale_bottom') ? document.querySelector('.site_wide_sale_bottom').style.top = viewportHeightEl - 75 + 'px' : null;   
	document.querySelector('.look_book_content_bottom') ? document.querySelector('.look_book_content_bottom').style.top = viewportHeightEl - 140 + 'px' : null;   
	// document.querySelector('.black_friday_25_content_link') ? document.querySelector('.black_friday_25_content_link').style.top = viewportHeightEl - 140 + 'px' : null;   
	document.querySelector('.black_friday_25_content_link') ? document.querySelector('.black_friday_25_content_link').style.top = viewportHeightEl - 70 + 'px' : null;   
	document.querySelector('.gifting_2k25_inner_bottom') ? document.querySelector('.gifting_2k25_inner_bottom').style.top = viewportHeightEl - 75 + 'px' : null;   
	document.querySelector('.father_day_v3_main') ? document.querySelector('.father_day_v3_main').style.top = viewportHeightEl - 200 + 'px' : null;   
	document.querySelector('.cut_from_tomorrow') ? document.querySelector('.cut_from_tomorrow').style.top = viewportHeightEl - 350 + 'px' : null;   

}

const GoogleConcernBar = () => {
	var _chk; try { _chk = localStorage.getItem("concentHide"); } catch(e) { _chk = null; }
	if (!_chk) {

		// window.allConsentReject = function(data) {
		// 	concerBar.remove();
		// 	if (data === 'reject') localStorage.setItem("concentHide", "true");
		// };

		let concerBar = document.createElement('div');
		concerBar.classList.add('concern_bar_main');
		concerBar.style.cssText = `position: fixed; z-index: 11111; width: 100%; bottom: 0; transition: .3s linear`;
		concerBar.innerHTML = `
			<div class="concern_bar_main_content" style="display: flex; justify-content: center; align-items: flex-end; flex-wrap: wrap; column-gap: 20px; padding: 10px 30px 15px 30px; background-color: #fff">
				<p class="text_center font_glacial" style="line-height: 1.1; padding-bottom: 5px;">This site uses cookies, to view our privacy Statement, <a href="/pages/cookie-policy" style="white-space: nowrap;">Read more...</a></p>
				<div style="display: flex; align-items: center; column-gap: 10px">
					<button class="presable_btn m0_imp" onclick="allConsentGranted()" style="font-size: 12px; padding: 4px 6px">Accept</button>
					<button class="presable_btn m0_imp" onclick="allConsentReject('reject')" style="font-size: 12px; padding: 4px 6px">Reject</button>
				</div>
				<div onclick="allConsentReject()" style="position: absolute; right: 0; top: 0; cursor: pointer; padding: 10px; line-height: 0">
					<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.6973 8.00025L14.8255 2.87209L15.883 1.81456C16.039 1.65855 16.039 1.40504 15.883 1.24904L14.7515 0.117504C14.5955 -0.0385011 14.3419 -0.0385011 14.1859 0.117504L8.00025 6.3032L1.81456 0.117004C1.65855 -0.0390012 1.40504 -0.0390012 1.24904 0.117004L0.117004 1.24854C-0.0390012 1.40454 -0.0390012 1.65805 0.117004 1.81406L6.3032 8.00025L0.117004 14.1859C-0.0390012 14.3419 -0.0390012 14.5955 0.117004 14.7515L1.24854 15.883C1.40454 16.039 1.65805 16.039 1.81406 15.883L8.00025 9.6973L13.1284 14.8255L14.1859 15.883C14.3419 16.039 14.5955 16.039 14.7515 15.883L15.883 14.7515C16.039 14.5955 16.039 14.3419 15.883 14.1859L9.6973 8.00025Z" fill="currentColor"></path></svg>
				</div>
			</div>
		`;
		document.body.append(concerBar);
	}
}

// update product page floating add to cart bar price
const productPriceEl = document.querySelector('#product-price');
const productPrice2El = document.querySelector('#product-price2');

const UpdateFloatingBarPrice = () => {
	const comPrice = productPriceEl.querySelector('.was');
	const price = productPriceEl.querySelector('.product-price');
	const saveAmount = productPriceEl.getAttribute('save_ammount');

	productPrice2El.innerHTML = (comPrice ? comPrice.outerHTML + ' ' : '') + (price ? price.outerHTML : '');
	if (saveAmount) productPrice2El.setAttribute('save_ammount', saveAmount);
}

if (productPriceEl && productPrice2El) {
	const productPriceOb = new MutationObserver(() => {
		UpdateFloatingBarPrice();
	});
	productPriceOb.observe(productPriceEl, config2);

	UpdateFloatingBarPrice();
}
/////////////////////////////////////////////////////

if (document.querySelector('.father-day')) {

	let productListSwiper;
	const productListSlider = () => {

		if (document.querySelector('.father-day .father_day_banner_inner') && document.querySelector('#shopify-section-header')) {          
			if (window.matchMedia("(max-width: 1299px)").matches) {
				document.querySelector('.father-day .father_day_banner_inner').style.minHeight = (window.innerHeight - document.querySelector('#shopify-section-header').offsetHeight) + 'px';
			} else {
				document.querySelector('.father-day .father_day_banner_inner').style.minHeight = '400px';
			}
		}
		//////////////////////////////////////

		if (window.matchMedia("(max-width: 991px)").matches) {
			if (!productListSwiper) {
				productListSwiper = new Swiper(".product_list_wrapper .mySwiper", {
					slidesPerView: 'auto',
					spaceBetween: 30,
					pagination: {
						el: ".product_list_wrapper .swiper-pagination",
						clickable: true,
					},
				});
			}
		} 
		else {
			if (productListSwiper && typeof productListSwiper.destroy === 'function') {
				productListSwiper.destroy(true, true);
				productListSwiper = undefined;
			}
		}
	};
	productListSlider();
	window.addEventListener('resize', productListSlider);
}



const videoLazyLoad = document.querySelectorAll('.video_lazy_load');

if (videoLazyLoad.length) {
  const videoLazyLoadHandle = (element) => {
    if (!element) return;

    const ismobile = window.matchMedia("(max-width: 767px)").matches;

		if (ismobile && element.getAttribute('mob_poster')) element.setAttribute('poster', element.getAttribute('mob_poster'));

    const videoUrl = element.getAttribute(ismobile && element.getAttribute('video_lazy_load_url_mob') ? 'video_lazy_load_url_mob' : 'video_lazy_load_url');

    const source = element.querySelector('source');
    if (source) {
      source.src = videoUrl;
      element.addEventListener('loadeddata', () => element.play().catch(console.error), { once: true });
      element.load();
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        videoLazyLoadHandle(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '100% 0px' });

  videoLazyLoad.forEach(element => observer.observe(element));
}

window.calculateReturnAmount = function(initialValue, discount) {
    initialValue = String(initialValue);
    
    // Remove any non-numeric characters except for the period (.)
    const currencySymbolOrCodeRegex = /[^\d.,\s]+/g;
    const currencyMatches = initialValue.match(currencySymbolOrCodeRegex) || [];
    const initialCurrencySymbol = currencyMatches.length > 0 ? currencyMatches[0] : '';
    const initialCurrencyCode = currencyMatches.length > 1 ? currencyMatches[1] : '';
    
    // Remove commas (for thousand separators) and parse the amount
    const initialAmount = parseFloat(initialValue.replace(/[^\d.]/g, '').replace(',', ''));

    if (!isNaN(initialAmount) && !isNaN(discount)) {
        let remainingAmount = initialAmount - ((discount * initialAmount) / 100);
        
        // Format the amount with commas for thousand separators
        const formattedAmount = remainingAmount.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        
        // Return the amount with currency symbol/code if present
        if (initialCurrencyCode) {
            return `${initialCurrencySymbol}${formattedAmount} ${initialCurrencyCode}`;
        } else {
            return `${initialCurrencySymbol}${formattedAmount}`;
        }
    } else {
        return 'Invalid Input';
    }
};

const sustainabilityObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
		entry.target.classList.add('visible');
		sustainabilityObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.3 
});


document.querySelectorAll('[data-sustainability-page-animation="true"]')?.forEach(section => {
  sustainabilityObserver.observe(section);
});